import React from 'react';
import * as util from "components/studio/toolbox/actions/Actions.lib.util";
import HelpMessage from 'components/util/helpers/HelpMessage';
// import l from "components/util/l";


const ActionElement = ({ action, app, isActive=false, isSuggestion=false, isDraggable=true, onClickAction, onDragStart }) => {

  const uiSettings = action.uiSettings;
  const hasSubtitle = uiSettings?.form?.subtitle != null || uiSettings?.general?.subtitle != null
  const hasCaption = uiSettings?.form?.caption != null || uiSettings?.general?.caption != null

  return (
    <div className="action-element">
  
        <a className={"btn btn-outline-secondary btn-action px-3 w-100 d-inline-block " + (isActive ? "active" : "")}
          draggable={isDraggable} onClick={() => onClickAction(action.id, app.id)}
          onDragStart={(event) => onDragStart(event, "node", action.id)} >

          <div className="d-flex align-items-start justify-content-start w-100">
            <i className={`app-icon ${app.uiSettings?.icon}`}></i>

            <div class="text-left">
              <div class="pb-0 mb-0 action-title">
                {util.getActionName(action)}
                {action.type == "TRIGGER" ?
                <span className={`action-trigger-label`}>({"Evento%SA231"})</span>
                : null}
                {action.developerOnly ? (
                  <span className="ml-1 d-block mb-1 action-note">
                    <i class="fas fa-code"></i> Developer only
                  </span>
                ) : null}
                {action.underDevelopment ? (
                  <span className="ml-1 d-block mb-1 action-note">
                    <i class="fas fa-wrench"></i> Under development
                  </span>
                ) : null}

              </div>

              <div className='action-subtitle'>
                {hasSubtitle ? <label className="d-block">
                  {uiSettings?.form?.subtitle ?? uiSettings?.general?.subtitle}</label> : null}
              </div>
              
              {hasCaption && !isSuggestion ?
              <div className='action-caption'>
                {uiSettings?.form?.caption ?? uiSettings?.general?.caption}
              </div>: null}

           
            </div>
          </div>
        </a>
    
    </div>
  );

}

const TabButton = ({ name, label, helpMessage, actionFilters, onClickFilterTab, onClickFilterRemove }) => {
  const isActive = actionFilters.includes(name)
  return (
    <HelpMessage message={helpMessage} placement="top" style={{marginBottom: "-10px"}}>
      <button className={"d-flex align-items-center rounded tab-button " + (isActive ? "active" : "")}
        style={{ paddingLeft: "0.75rem", paddingRight: (isActive ? "0.4rem" : "0.75rem"), whiteSpace: "nowrap" }}
        onClick={() => onClickFilterTab(name)}>
        {label}
        <i class="ml-2 fas fa-times-circle" onClick={() => onClickFilterRemove(name)}></i>
      </button>
    </HelpMessage>
  )

}



export { ActionElement, TabButton };